import { createSSRApp } from 'vue'

import * as Pinia from 'pinia'

import AppRoot from './App.vue'

import '@unocss/reset/tailwind.css'
import 'uno.css'
import '~/styles/index.scss'
import { showAlert } from './utils/tools'

function forbidCookieInSafari() {
  try {
    localStorage.getItem('anything')
    return false
  }
  catch {
    return true
  }
}

export function createApp() {
  if (forbidCookieInSafari()) {
    showAlert('请前往设置中启用 Cookie，然后刷新页面').then(() => location.reload())
    return
  }
  const app = createSSRApp(AppRoot)
  app.use(Pinia.createPinia())
  return {
    app,
    Pinia,
  }
}

window.addEventListener('pageshow', (e) => {
  if (e.persisted)
    location.reload()
})

window.addEventListener('unload', () => {
  // do nothing
  // just try to prevent browser put this into bfcache
})
